import { getTokenLocal } from "utils/localStorage.util";
import ApiRoutes from "../configs/endpoints.config";
import HttpClient from "./index.api";
const baseURL = process.env.REACT_APP_API_URL;

class CouponApi extends HttpClient {
    constructor() {
        super(baseURL);
        this._initializeRequestInterceptor();
        this._initializeResponseInterceptor();
    }

    _initializeRequestInterceptor = () => {
        this.instance.interceptors.request.use((config) => {
            config.headers["Authorization"] = `Bearer ${getTokenLocal()}`;
            return config;
        });
    };

    _initializeResponseInterceptor = () => {
        this.instance.interceptors.response.use(
            (response) => {
                return response;
            },
            (response) => {
                return Promise.resolve(response);
            }
        );
    };

    CreateCouponConfig = ApiRoutes.CouponDiscount.CreateCoupon;
    UpdateCouponConfig = ApiRoutes.CouponDiscount.UpdateCoupon;
    GetAllCouponsConfig = ApiRoutes.CouponDiscount.GetAllCoupons;
    DeleteCouponConfig = ApiRoutes.CouponDiscount.DeleteCoupon;

    createCoupon = async (data) => {
        return this.instance({
            method: this.CreateCouponConfig.Method,
            url: this.CreateCouponConfig.Endpoint,
            data,
        });
    };

    getAllCoupons = async () => {
        return this.instance({
            method: this.GetAllCouponsConfig.Method,
            url: this.GetAllCouponsConfig.Endpoint,
        });
    };

    updateCoupon = async (couponId, data) => {
        return this.instance({
            method: this.UpdateCouponConfig.Method,
            url: this.UpdateCouponConfig.Endpoint(couponId),
            data,
        });
    };

    deleteCoupon = async (couponId) => {
        return this.instance({
            method: this.DeleteCouponConfig.Method,
            url: this.DeleteCouponConfig.Endpoint(couponId),
        });
    };
}

export default CouponApi;
